(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-best-sellers')) {
    class FeaturedCollectionBestSellers extends HTMLElement {
      constructor() {
        super();
        this.loaded = false;
        this.loading = false;
        this.retryAttempts = 0;
        this.retryTimeout = null;
        this.maxRetryAttempts = 3;
        this.retryLimitReached = false;
        this.lists = Array.from(this.querySelectorAll('[data-featured-collection-best-sellers="true"]'));
        this.toggleButtons = this.querySelectorAll('.featured-collection__toggle');
        this.toggleButtons.forEach((button) => button.addEventListener('click', this.onToggleClick.bind(this)));

        if (!this.lists.length) return;

        this.loadProducts = async () => {
          if (this.loaded || this.loading || this.retryLimitReached) return;
          this.clearLoadRetry();

          const loaded = await this.loadBestSellers();

          if (loaded) {
            this.retryAttempts = 0;
            this.retryLimitReached = false;
            this.carouselObserver?.disconnect();
          } else {
            this.scheduleLoadRetry(this.loadProducts);
          }
        };

        if ('IntersectionObserver' in window) {
          const handleIntersection = (entries) => {
            if (!entries[0].isIntersecting) return;
            this.loadProducts();
          };

          this.carouselObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
          this.carouselObserver.observe(this);
        } else {
          this.loadProducts();
        }

        setTimeout(this.loadProducts, 2000);
      }

      async loadBestSellers() {
        const token = this.dataset.storefrontAccessToken;
        const apiVersion = this.dataset.apiVersion || '2026-04';
        const limit = Math.max(1, Number(this.dataset.productsToShow) || 4);

        if (!token) {
          this.lists.forEach((list) => this.renderEmptyState(list));
          console.error('Featured Collection requires a Storefront access token for best-seller sorting.');
          return false;
        }

        this.loading = true;

        try {
          const results = await Promise.all(this.lists.map((list) => this.loadList(list, token, apiVersion, limit)));
          const loaded = results.every(Boolean);
          this.loaded = loaded;

          if (typeof lazyImages === 'function') lazyImages();
          return loaded;
        } catch (error) {
          this.loaded = false;
          console.error(error);
          return false;
        } finally {
          this.loading = false;
        }
      }

      async loadList(list, token, apiVersion, limit) {
        if (list.dataset.loaded === 'true') return true;

        const collectionHandle = list.dataset.collectionHandle;
        if (!collectionHandle) {
          this.renderEmptyState(list);
          return false;
        }

        try {
          const handles = await this.fetchBestSellerHandles(collectionHandle, limit, token, apiVersion);
          const cardHtml = await Promise.all(handles.map((handle) => this.fetchProductCard(handle, list.dataset.blockId)));
          const cards = cardHtml.filter(Boolean).slice(0, limit);

          if (!cards.length) {
            this.renderEmptyState(list);
            return false;
          }

          const itemClasses = ['grid__item'];
          if (list.classList.contains('slider')) {
            itemClasses.push('slider__slide');
          }

          list.innerHTML = cards.map((html, index) => {
            return `<li role="listitem" class="${itemClasses.join(' ')}" id="Slide-${list.dataset.blockId}-${index + 1}">${html}</li>`;
          }).join('');
          list.dataset.loaded = 'true';
          list.removeAttribute('aria-busy');
          this.resetSlider(list);
          return true;
        } catch (error) {
          this.renderEmptyState(list);
          console.error(error);
          return false;
        }
      }

      clearLoadRetry() {
        window.clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
      }

      scheduleLoadRetry(callback) {
        if (this.loaded || this.retryTimeout || !this.isConnected || this.retryLimitReached) return;
        if (this.retryAttempts >= this.maxRetryAttempts) {
          this.retryLimitReached = true;
          this.carouselObserver?.disconnect();
          return;
        }

        this.retryAttempts += 1;
        this.retryTimeout = window.setTimeout(() => {
          this.retryTimeout = null;
          callback();
        }, 2000 * this.retryAttempts);
      }

      async fetchBestSellerHandles(collectionHandle, limit, token, apiVersion) {
        const handles = [];
        let cursor = null;
        let hasNextPage = true;
        let pagesFetched = 0;
        const pageSize = Math.min(50, Math.max(limit * 2, limit));

        while (handles.length < limit && hasNextPage && pagesFetched < 5) {
          const products = await this.fetchBestSellerProductsPage(collectionHandle, pageSize, cursor, token, apiVersion);
          pagesFetched += 1;
          hasNextPage = Boolean(products?.pageInfo?.hasNextPage);
          cursor = products?.pageInfo?.endCursor || null;

          (products?.nodes || [])
            .filter((product) => product.handle)
            .filter((product) => product.metafield?.value !== 'true')
            .filter((product) => !product.tags?.includes('HIDDEN'))
            .filter((product) => product.vendor !== 'EVG')
            .forEach((product) => {
              if (handles.length < limit) handles.push(product.handle);
            });
        }

        return handles;
      }

      async fetchBestSellerProductsPage(collectionHandle, limit, cursor, token, apiVersion) {
        const response = await fetch(`/api/${apiVersion}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({
            query: `
              query FeaturedCollectionBestSellers($handle: String!, $limit: Int!, $after: String) {
                collection(handle: $handle) {
                  products(first: $limit, after: $after, sortKey: BEST_SELLING) {
                    pageInfo {
                      hasNextPage
                      endCursor
                    }
                    nodes {
                      handle
                      vendor
                      tags
                      metafield(namespace: "inventory", key: "ShappifyHidden") {
                        value
                      }
                    }
                  }
                }
              }
            `,
            variables: {
              handle: collectionHandle,
              limit,
              after: cursor
            }
          })
        });

        if (!response.ok) throw new Error(`Featured Collection GraphQL request failed with ${response.status}`);

        const payload = await response.json();
        if (payload.errors) throw new Error(payload.errors.map((error) => error.message).join(', '));

        return payload.data?.collection?.products;
      }

      async fetchProductCard(handle, blockId) {
        const view = this.dataset.showLifeImage === 'true' ? 'card-product-life-image' : 'card-product';
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=${view}`);
        if (!response.ok) return '';

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.card-wrapper');

        if (card) this.applyCardSettings(card, blockId);

        return card ? card.outerHTML : '';
      }

      applyCardSettings(card, blockId) {
        this.scopeCardIds(card, blockId);
        this.updateImageRatio(card);
        const showSecondaryImage = this.dataset.showSecondaryImage === 'true';
        card.setAttribute('data-show-secondary-image', showSecondaryImage);
        card.querySelector('.card')?.setAttribute('data-show-secondary-image', showSecondaryImage);

        if (this.dataset.showSecondaryImage !== 'true') {
          card.querySelectorAll('.card__hover-image').forEach((element) => element.remove());
        }

        if (this.dataset.showQuickAdd !== 'true') {
          card.querySelectorAll('quick-add, .quick-add__colors').forEach((element) => element.remove());
        }

        if (this.dataset.showRating !== 'true') {
          card.querySelectorAll('.card__rating, .klaviyo-star-rating-widget').forEach((element) => element.remove());
        }

        if (this.dataset.showVendor !== 'true') {
          card.querySelectorAll('.caption-with-letter-spacing.light').forEach((element) => element.remove());
        }
      }

      scopeCardIds(card, blockId) {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        card.querySelectorAll('[id]').forEach((element) => {
          element.id = element.id.replace(/product-card-view/g, `${sectionId}-${blockId}`);
        });
      }

      updateImageRatio(card) {
        const ratioPercent = {
          portrait: '125%',
          square: '100%'
        }[this.dataset.imageRatio];

        if (!ratioPercent) return;

        card.querySelectorAll('.card, .card__inner').forEach((element) => {
          element.style.setProperty('--ratio-percent', ratioPercent);
        });
      }

      renderEmptyState(list) {
        list.innerHTML = '';
        list.removeAttribute('aria-busy');
        this.resetSlider(list);
      }

      onToggleClick(event) {
        const sliderId = event.currentTarget.getAttribute('aria-controls');
        const list = document.getElementById(sliderId);

        window.requestAnimationFrame(() => {
          this.updateSliderButtons(sliderId);

          if (list?.dataset.featuredCollectionBestSellers === 'true' && list.dataset.loaded !== 'true' && !this.loading) {
            const token = this.dataset.storefrontAccessToken;
            const apiVersion = this.dataset.apiVersion || '2026-04';
            const limit = Math.max(1, Number(this.dataset.productsToShow) || 4);

            this.loadList(list, token, apiVersion, limit).then((loaded) => {
              if (loaded && typeof lazyImages === 'function') lazyImages();
            });
          } else if (list) {
            this.resetSlider(list);
          }
        });
      }

      updateSliderButtons(sliderId) {
        this.querySelectorAll('.slider-buttons[data-slider]').forEach((buttons) => {
          buttons.style.display = buttons.dataset.slider === sliderId ? '' : 'none';
        });
      }

      resetSlider(list) {
        if (!list || !list.classList.contains('slider')) return;

        const slider = this.querySelector('slider-component');
        if (!slider || typeof slider.resetPages !== 'function') return;
        if (list.offsetParent === null && window.getComputedStyle(list).display === 'none') return;

        const sliderId = list.getAttribute('id');
        slider.currentPageElement = this.querySelector(`#slider-buttons-${list.dataset.blockId} .slider-counter--current`);
        slider.pageTotalElement = this.querySelector(`#slider-buttons-${list.dataset.blockId} .slider-counter--total`);
        if (typeof slider.setActiveSlider === 'function') {
          slider.setActiveSlider(list);
        } else {
          slider.slider = list;
          slider.sliderItems = list.querySelectorAll('.slider__slide');
          slider.prevButton = slider.querySelector(`button[name="previous"][aria-controls="${sliderId}"]`);
          slider.nextButton = slider.querySelector(`button[name="next"][aria-controls="${sliderId}"]`);
        }

        if (slider.prevButton && slider.nextButton) slider.resetPages();
      }
    }

    customElements.define('featured-collection-best-sellers', FeaturedCollectionBestSellers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-3-reviews"]) return;
  try {
    
  if (!customElements.get('key-three-reviews')) {
    customElements.define('key-three-reviews', class KeyThreeReviews extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-review-config]').textContent);
        this.messages = this.config.messages;
        this.list = this.querySelector('[data-review-list]');
        this.status = this.querySelector('[data-review-status]');
        this.more = this.querySelector('[data-review-more]');
        this.generation = 0;
        this.querySelectorAll('[data-review-filter]').forEach((button) => button.addEventListener('click', () => {
          this.observer?.disconnect();
          this.select(button.dataset.reviewFilter);
        }));
        this.more.addEventListener('click', () => this.loadMore());
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.observer.disconnect();
            this.select('all');
          }
        }, { rootMargin: '300px' });
        this.observer.observe(this);
      }

      async select(filter) {
        this.generation++;
        this.busy = false;
        this.filter = filter;
        this.streams = this.config.sources.filter((source) => filter === 'all' || source.id === filter).map((source) => ({ source, buffer: [], offset: 0, hasMore: true, summary: null }));
        this.seen = new Set();
        this.list.replaceChildren();
        this.querySelector('[data-review-summary]').textContent = '';
        this.querySelectorAll('[data-review-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.reviewFilter === filter)));
        await this.loadMore();
      }

      async fill(stream, generation) {
        if (stream.buffer.length || !stream.hasMore) return;
        const params = new URLSearchParams({ product_id: stream.source.id, company_id: this.dataset.companyId, limit: '12', offset: String(stream.offset), sort: '0', type: 'reviews', media: 'false' });
        const response = await fetch(`https://fast.a.klaviyo.com/reviews/api/client_reviews/${encodeURIComponent(stream.source.id)}/?${params}`, { credentials: 'omit', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Reviews unavailable');
        const data = await response.json();
        if (generation !== this.generation) return;
        if (String(data.summary?.product_id) !== stream.source.id || !Array.isArray(data.reviews)) throw new Error('Unexpected review source');
        stream.summary = data.summary;
        stream.offset += data.reviews.length;
        stream.hasMore = Boolean(data.has_more && data.reviews.length);
        stream.buffer = data.reviews.filter((review) => review.status === 'Published' && review.rating >= 1 && review.rating <= 5).map((review) => ({ ...review, source: stream.source }));
        if (!stream.buffer.length) stream.hasMore = false;
      }

      async loadMore() {
        if (this.busy) return;
        this.busy = true;
        const generation = this.generation;
        const streams = this.streams;
        this.more.disabled = true;
        this.status.textContent = this.messages.loading;
        this.setAttribute('aria-busy', 'true');
        try {
          let added = 0;
          while (added < 6) {
            const results = await Promise.allSettled(streams.map((stream) => this.fill(stream, generation)));
            if (generation !== this.generation) return;
            if (results.some((result) => result.status === 'rejected')) throw new Error('Reviews unavailable');
            const ready = streams.filter((stream) => stream.buffer.length);
            if (!ready.length) break;
            ready.sort((a,b) => new Date(b.buffer[0].created_at) - new Date(a.buffer[0].created_at));
            const review = ready[0].buffer.shift();
            if (this.seen.has(review.id)) continue;
            this.seen.add(review.id);
            this.list.append(this.card(review));
            added++;
          }
          let count = 0;
          let score = 0;
          for (const stream of streams) {
            const histogram = stream.summary?.rating_histogram || [];
            histogram.forEach((value, index) => { count += Number(value); score += Number(value) * (index + 1); });
          }
          this.querySelector('[data-review-summary]').textContent = count ? this.messages.summary.replace('[rating]', (score/count).toFixed(2)).replace('[count]', count.toLocaleString()) : '';
          this.status.textContent = this.list.children.length ? this.messages.showing.replace('[count]', this.list.children.length) : this.messages.empty;
          this.more.textContent = this.messages.more;
          this.more.hidden = !streams.some((stream) => stream.buffer.length || stream.hasMore);
        } catch {
          if (generation !== this.generation) return;
          this.status.textContent = this.messages.failed;
          this.more.textContent = this.messages.retry;
          this.more.hidden = false;
        } finally {
          if (generation === this.generation) {
            this.busy = false;
            this.more.disabled = false;
            this.setAttribute('aria-busy', 'false');
          }
        }
      }

      card(review) {
        const item = document.createElement('li');
        item.className = 'key-three-review';
        const add = (tag, className, text, parent = item) => {
          const node = document.createElement(tag);
          node.className = className;
          node.textContent = text;
          parent.append(node);
          return node;
        };
        const product = add('a', 'key-three-review__product', review.source.title);
        product.href = `${review.source.url}#fulfilled-reviews-all`;
        const stars = add('p', 'key-three-review__stars', '★'.repeat(Math.round(review.rating)) + '☆'.repeat(5-Math.round(review.rating)));
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', this.messages.rating.replace('[rating]', review.rating));
        if (review.title) add('h3', '', review.title);
        if (review.content) add('p', 'key-three-review__content', review.content);
        if (review.author) add('p', 'key-three-review__author', review.author);
        if (review.verified) add('span', 'key-three-review__badge', this.messages.verified);
        if (review.incentive_type) add('span', 'key-three-review__badge', this.messages.incentivized);
        const date = new Date(review.created_at);
        if (!Number.isNaN(date.getTime())) {
          const time = add('time', 'key-three-review__date', date.toLocaleDateString(document.documentElement.lang || 'en', { month:'short', day:'numeric', year:'numeric' }));
          time.dateTime = date.toISOString();
        }
        if (review.public_reply_content) {
          const reply = add('details', '', '');
          add('summary', '', this.messages.reply, reply);
          add('p', 'key-three-review__reply', review.public_reply_content, reply);
        }
        return item;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-key-3"]) return;
  try {
    
  if (!customElements.get('key-three-bundle')) {
    customElements.define('key-three-bundle', class KeyThreeBundle extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.buttonText = this.querySelector('[data-button-text]');
        this.error = this.querySelector('[data-error]');
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.root = this.dataset.rootUrl.replace(/\/?$/, '/');
        const currency = window.Shopify?.currency;
        const rate = currency?.active === this.dataset.currency ? Number(currency.rate) : 0;
        this.discount = this.dataset.currency === 'USD' ? 4000 : rate > 0 ? Math.round(4000 * rate) : Number(this.dataset.discountAmount);
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
        this.components = Array.from(this.querySelectorAll('[data-component]'), (element) => ({
          element,
          ...JSON.parse(element.querySelector('[data-component-data]').textContent),
          color: '',
          size: ''
        }));
        this.form.addEventListener('change', (event) => this.changeSelection(event));
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.refresh();
      }

      variant(component) {
        if (!component.color || (!component.fixedSize && !component.size)) return null;
        return component.variants.find((variant) => variant.options[component.colorIndex] === component.color && variant.options[component.sizeIndex] === (component.fixedSize || component.size));
      }

      changeSelection(event) {
        const component = this.components.find((item) => item.element.contains(event.target));
        if (!component || !event.target.matches('input[data-kind]')) return;
        const kind = event.target.dataset.kind;
        component[kind] = event.target.value;
        if (kind === 'color') {
          component.size = '';
          component.element.querySelectorAll('[data-kind="size"]').forEach((input) => { input.checked = false; });
          this.updateImages(component);
        }
        if (!this.uncertain) this.error.hidden = true;
        this.refresh();
      }

      refresh() {
        let ready = this.components.length === 3;
        for (const component of this.components) {
          const valid = component.id && component.colorIndex >= 0 && component.sizeIndex >= 0 && component.variants.length > 0;
          component.element.disabled = !valid || Boolean(this.busy);
          const variant = this.variant(component);
          ready = ready && Boolean(valid && variant?.available);
          component.element.querySelectorAll('[data-kind="color"]').forEach((input) => {
            input.disabled = !component.variants.some((item) => item.available && item.options[component.colorIndex] === input.value && (!component.fixedSize || item.options[component.sizeIndex] === component.fixedSize));
            input.dataset.unavailable = String(input.disabled);
            input.nextElementSibling.title = input.value + (input.disabled ? ` — ${this.messages.soldOut}` : '');
          });
          const sizes = component.element.querySelector('[data-option="size"]');
          if (sizes) sizes.disabled = !component.color;
          component.element.querySelectorAll('[data-kind="size"]').forEach((input) => {
            input.disabled = Boolean(component.color) && !component.variants.some((item) => item.available && item.options[component.colorIndex] === component.color && item.options[component.sizeIndex] === input.value);
            input.dataset.unavailable = String(input.disabled);
            input.nextElementSibling.title = input.disabled ? this.messages.soldOut : input.nextElementSibling.textContent.trim();
          });
          for (const kind of ['color', 'size']) {
            const label = component.element.querySelector(`[data-selection="${kind}"]`);
            if (label) label.textContent = component[kind] || this.messages.choose;
          }
          component.element.querySelector('[data-component-status]').textContent = !valid || (variant && !variant.available) ? this.messages.unavailable : '';
        }
        this.button.disabled = !ready || Boolean(this.busy) || Boolean(this.uncertain);
        this.buttonText.textContent = this.busy ? this.messages.adding : this.messages.add;
        this.querySelector('[data-progress]').textContent = ready ? this.messages.ready : this.messages.selectAll;
        this.form.setAttribute('aria-busy', String(Boolean(this.busy)));
        this.updatePrice(ready);
      }

      updatePrice(ready) {
        const prices = this.components.map((component) => {
          const selected = this.variant(component);
          if (selected) return selected.price;
          const available = component.variants.filter((variant) => variant.available && (!component.color || variant.options[component.colorIndex] === component.color) && (!component.fixedSize || variant.options[component.sizeIndex] === component.fixedSize));
          return available.length ? Math.min(...available.map((variant) => variant.price)) : null;
        });
        this.querySelector('[data-price]').hidden = prices.length !== 3 || prices.some((price) => price === null);
        const total = prices.reduce((sum, price) => sum + price, 0);
        this.querySelector('[data-price-from]').hidden = ready;
        this.querySelector('[data-regular-price]').textContent = this.money.format(total / 100);
        this.querySelector('[data-set-price]').textContent = this.money.format((total - Math.min(this.discount, prices[2])) / 100);
      }

      updateImages(component) {
        const matches = component.images.filter((image) => {
          const parts = image.alt.split(' | ').map((part) => part.trim());
          const colors = parts[0].split(',').map((part) => part.trim().toLowerCase());
          return colors.includes(component.color.toLowerCase()) && (!component.fixedSize || parts[1] === component.fixedSize);
        });
        if (!matches.length) return;
        this.querySelectorAll(`[data-gallery-component="${component.element.dataset.index}"] img`).forEach((image, index) => {
          const next = matches[index] || matches[0];
          image.removeAttribute('srcset');
          image.src = next.src;
          image.alt = next.alt;
        });
      }

      async request(path, options = {}) {
        const response = await fetch(path, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000), ...options });
        const data = await response.json();
        if (!response.ok) throw new Error(this.messages.failed);
        return data;
      }

      async verifyAddition(group, variants, response) {
        const cart = await this.request(`${this.root}cart.js`);
        const items = cart.items.filter((item) => item.properties?._key_3_set === group);
        if (items.length === 3 && variants.every((variant) => items.some((item) => item.variant_id === variant.id && item.quantity === 1))) return cart;
        if (items.length) {
          await this.request(`${this.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: Object.fromEntries(items.map((item) => [item.key, 0])) })
          });
          const restored = await this.request(`${this.root}cart.js`);
          if (restored.items.some((item) => item.properties?._key_3_set === group)) throw new Error(this.messages.uncertain);
          this.uncertain = false;
        } else if (response && response.status >= 400 && response.status < 500) {
          this.uncertain = false;
        }
        throw new Error(this.uncertain ? this.messages.uncertain : this.messages.failed);
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy || this.uncertain || this.button.disabled || !this.form.reportValidity()) return;
        this.busy = true;
        this.error.hidden = true;
        this.refresh();
        try {
          const quotedPrices = this.components.map((component) => this.variant(component).price);
          const [cart, ...products] = await Promise.all([
            this.request(`${this.root}cart.js`),
            ...this.components.map((component) => this.request(`${component.url}.js`))
          ]);
          products.forEach((product, index) => { this.components[index].variants = product.variants; });
          const variants = this.components.map((component) => this.variant(component));
          if (variants.some((variant) => !variant?.available)) throw new Error(this.messages.unavailable);
          if (cart.currency !== this.dataset.currency) throw new Error(this.messages.currencyChanged);
          if (variants.some((variant, index) => variant.price !== quotedPrices[index])) throw new Error(this.messages.priceChanged);
          const group = crypto.randomUUID();
          this.uncertain = true;
          let response;
          try {
            response = await fetch(`${this.root}cart/add.js`, {
              method: 'POST',
              credentials: 'same-origin',
              signal: AbortSignal.timeout(15000),
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: variants.map((variant) => ({ id: variant.id, quantity: 1, properties: { _key_3_set: group } })) })
            });
          } catch {}
          await this.verifyAddition(group, variants, response);
          this.uncertain = false;
          const drawer = document.querySelector('cart-drawer');
          if (typeof drawer?.renderContents === 'function') {
            try {
              drawer.setActiveElement(this.button);
              await drawer.renderContents({});
              drawer.classList.remove('is-empty');
              drawer.open();
            } catch {
              window.location.assign(this.dataset.cartUrl);
            }
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
          this.querySelector('[data-progress]').textContent = this.messages.added;
        } catch (error) {
          this.error.textContent = this.uncertain ? this.messages.uncertain : error.message || this.messages.failed;
          this.error.hidden = false;
          this.querySelector('[data-check-cart]').hidden = !this.uncertain;
          this.error.focus();
        } finally {
          this.busy = false;
          const progress = this.querySelector('[data-progress]').textContent;
          this.refresh();
          if (progress === this.messages.added) this.querySelector('[data-progress]').textContent = progress;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-carousel')) {
    class ProductCarousel extends HTMLElement {
      constructor() {
        super();
        this.loaded = false;
        this.loading = false;
        this.retryAttempts = 0;
        this.retryTimeout = null;
        this.maxRetryAttempts = 3;
        this.retryLimitReached = false;

        if (!this.dataset.collectionHandle) return;

        const loadProducts = async () => {
          if (this.loaded || this.loading || this.retryLimitReached) return;
          this.clearLoadRetry();

          const loaded = await this.loadBestSellers();

          if (loaded) {
            this.retryAttempts = 0;
            this.retryLimitReached = false;
            this.carouselObserver?.disconnect();
          } else {
            this.scheduleLoadRetry(loadProducts);
          }
        };

        if ('IntersectionObserver' in window) {
          const handleIntersection = (entries) => {
            if (!entries[0].isIntersecting) return;
            loadProducts();
          };

          this.carouselObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
          this.carouselObserver.observe(this);
        } else {
          loadProducts();
        }

        setTimeout(loadProducts, 2000);
      }

      async loadBestSellers() {
        const list = this.querySelector('[data-product-carousel-list]');
        const token = this.dataset.storefrontAccessToken;
        const collectionHandle = this.dataset.collectionHandle;
        const apiVersion = this.dataset.apiVersion || '2026-04';
        const limit = Math.max(1, Number(this.dataset.productsToShow) || 8);

        if (!list || !collectionHandle || !token) {
          this.renderEmptyState();
          if (!token) console.error('Product Carousel requires a Storefront access token for best-seller sorting.');
          return false;
        }

        this.loading = true;

        try {
          const handles = await this.fetchBestSellerHandles(collectionHandle, limit, token, apiVersion);
          const cardHtml = await Promise.all(handles.map((handle) => this.fetchProductCard(handle)));
          const cards = cardHtml.filter(Boolean).slice(0, limit);

          if (!cards.length) {
            this.renderEmptyState();
            this.loaded = false;
            return false;
          }

          const itemClasses = ['grid__item'];
          if (
            this.dataset.desktopCarousel === 'true' ||
            this.dataset.mobileLayout === 'carousel' ||
            this.dataset.layout === 'mobile_carousel' ||
            this.dataset.layout === 'carousel'
          ) {
            itemClasses.push('slider__slide');
          }

          list.innerHTML = cards.map((html, index) => {
            return `<li class="${itemClasses.join(' ')}" id="Slide-${this.dataset.sectionId}-${index + 1}">${html}</li>`;
          }).join('');
          this.loaded = true;
          this.classList.add('product-recommendations--loaded');
          this.resetSlider();

          if (typeof lazyImages === 'function') lazyImages();
          return true;
        } catch (error) {
          this.loaded = false;
          this.renderEmptyState();
          console.error(error);
          return false;
        } finally {
          this.loading = false;
        }
      }

      clearLoadRetry() {
        window.clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
      }

      scheduleLoadRetry(callback) {
        if (this.loaded || this.retryTimeout || !this.isConnected || this.retryLimitReached) return;
        if (this.retryAttempts >= this.maxRetryAttempts) {
          this.retryLimitReached = true;
          this.carouselObserver?.disconnect();
          return;
        }

        this.retryAttempts += 1;
        this.retryTimeout = window.setTimeout(() => {
          this.retryTimeout = null;
          callback();
        }, 2000 * this.retryAttempts);
      }

      async fetchBestSellerHandles(collectionHandle, limit, token, apiVersion) {
        const handles = [];
        let cursor = null;
        let hasNextPage = true;
        let pagesFetched = 0;
        const pageSize = Math.min(50, Math.max(limit * 2, limit));

        while (handles.length < limit && hasNextPage && pagesFetched < 5) {
          const products = await this.fetchBestSellerProductsPage(collectionHandle, pageSize, cursor, token, apiVersion);
          pagesFetched += 1;
          hasNextPage = Boolean(products?.pageInfo?.hasNextPage);
          cursor = products?.pageInfo?.endCursor || null;

          (products?.nodes || [])
            .filter((product) => product.handle)
            .filter((product) => product.metafield?.value !== 'true')
            .filter((product) => !product.tags?.includes('HIDDEN'))
            .filter((product) => product.vendor !== 'EVG')
            .forEach((product) => {
              if (handles.length < limit) handles.push(product.handle);
            });
        }

        return handles;
      }

      async fetchBestSellerProductsPage(collectionHandle, limit, cursor, token, apiVersion) {
        const response = await fetch(`/api/${apiVersion}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({
            query: `
              query ProductCarouselBestSellers($handle: String!, $limit: Int!, $after: String) {
                collection(handle: $handle) {
                  products(first: $limit, after: $after, sortKey: BEST_SELLING) {
                    pageInfo {
                      hasNextPage
                      endCursor
                    }
                    nodes {
                      handle
                      vendor
                      tags
                      metafield(namespace: "inventory", key: "ShappifyHidden") {
                        value
                      }
                    }
                  }
                }
              }
            `,
            variables: {
              handle: collectionHandle,
              limit,
              after: cursor
            }
          })
        });

        if (!response.ok) throw new Error(`Product Carousel GraphQL request failed with ${response.status}`);

        const payload = await response.json();
        if (payload.errors) throw new Error(payload.errors.map((error) => error.message).join(', '));

        return payload.data?.collection?.products;
      }

      async fetchProductCard(handle) {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=card-product`);
        if (!response.ok) return '';

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.card-wrapper');

        if (card) this.applyCardSettings(card);

        return card ? card.outerHTML : '';
      }

      applyCardSettings(card) {
        this.scopeCardIds(card);
        this.updateImageRatio(card);
        const showSecondaryImage = this.dataset.showSecondaryImage === 'true';
        card.setAttribute('data-show-secondary-image', showSecondaryImage);
        card.querySelector('.card')?.setAttribute('data-show-secondary-image', showSecondaryImage);

        if (this.dataset.showSecondaryImage !== 'true') {
          card.querySelectorAll('.card__hover-image').forEach((element) => element.remove());
        }

        if (this.dataset.showQuickAdd !== 'true') {
          card.querySelectorAll('quick-add, .quick-add__colors').forEach((element) => element.remove());
        }

        if (this.dataset.showRating !== 'true') {
          card.querySelectorAll('.card__rating, .klaviyo-star-rating-widget').forEach((element) => element.remove());
        }

        if (this.dataset.showVendor !== 'true') {
          card.querySelectorAll('.caption-with-letter-spacing.light').forEach((element) => element.remove());
        }
      }

      scopeCardIds(card) {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        card.querySelectorAll('[id]').forEach((element) => {
          element.id = element.id.replace(/product-card-view/g, sectionId);
        });
      }

      updateImageRatio(card) {
        const ratioPercent = {
          portrait: '125%',
          square: '100%'
        }[this.dataset.imageRatio];

        if (!ratioPercent) return;

        card.querySelectorAll('.card, .card__inner').forEach((element) => {
          element.style.setProperty('--ratio-percent', ratioPercent);
        });
      }

      renderEmptyState() {
        const list = this.querySelector('[data-product-carousel-list]');
        if (list) list.innerHTML = '';
        this.classList.remove('product-recommendations--loaded');
        this.resetSlider();
      }

      resetSlider() {
        const slider = this.closest('slider-component');
        const sliderList = slider?.querySelector('.slider');
        if (!slider || !sliderList || typeof slider.resetPages !== 'function') return;

        const sliderId = sliderList.getAttribute('id');
        const hasSliderControls = slider.querySelector(`button[name="previous"][aria-controls="${sliderId}"]`)
          && slider.querySelector(`button[name="next"][aria-controls="${sliderId}"]`);

        if (hasSliderControls) slider.resetPages();
      }
    }

    customElements.define('product-carousel', ProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-faq-accordion')) {
    class ProductFaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.querySelectorAll('summary').forEach((summary) => {
          summary.setAttribute('aria-expanded', summary.parentElement.open);
        });
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary)) return;

        event.preventDefault();
        const selectedItem = summary.parentElement;
        const shouldOpen = !selectedItem.open;

        this.querySelectorAll('details[open]').forEach((item) => {
          item.open = false;
          item.querySelector('summary').setAttribute('aria-expanded', 'false');
        });

        selectedItem.open = shouldOpen;
        summary.setAttribute('aria-expanded', shouldOpen);
      }
    }

    customElements.define('product-faq-accordion', ProductFaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
      this.loading = false;
      this.retryAttempts = 0;
      this.retryTimeout = null;
      this.maxRetryAttempts = 3;
      this.refreshTimer = null;
      this.onVisibility = () => { if (!document.hidden) this.refreshRecommendations(); };
      this.retryLimitReached = false;

      const loadRecommendations = async () => {
        if (!this.isConnected || this.loaded || this.loading || this.retryLimitReached) return;
        this.clearLoadRetry();

        const loaded = await this.fetchRecommendations();

        if (loaded) {
          this.retryAttempts = 0;
          this.retryLimitReached = false;
          this.recommendationsObserver?.disconnect();
        } else {
          this.scheduleLoadRetry(loadRecommendations);
        }
      };

      const handleIntersection = (entries) => {
        if (!entries[0].isIntersecting) return;
        loadRecommendations();
      }

      this.recommendationsObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'});
      this.recommendationsObserver.observe(this);
      setTimeout(loadRecommendations, 2000);
    }

    connectedCallback() {
      if (this.refreshTimer) return;
      this.refreshTimer = window.setInterval(() => {
        if (document.hidden || !this.isConnected || this.contains(document.activeElement)) return;
        this.refreshRecommendations();
      }, 30000);
      document.addEventListener('visibilitychange', this.onVisibility);
    }

    disconnectedCallback() {
      window.clearInterval(this.refreshTimer);
      this.refreshTimer = null;
      this.clearLoadRetry();
      this.recommendationsObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    async refreshRecommendations() {
      if (this.loading || this.contains(document.activeElement)) return;
      const until = Number(this.dataset.guardUntil);
      if (until && until <= Date.now() / 1000) this.innerHTML = '';
      await this.fetchRecommendations();
    }

    async fetchRecommendations() {
      this.loading = true;

      try {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('_refresh', Math.floor(Date.now() / 30000));
        const response = await fetch(url, {cache: 'no-store'});
        if (!response.ok) throw new Error('Recommendation refresh failed');
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        this.dataset.guardUntil = recommendations?.dataset.guardUntil || '0';
        this.innerHTML = recommendations ? recommendations.innerHTML : '';
        if (!this.querySelector('.grid__item:not(.product-recommendations__skeleton-card)')) this.innerHTML = '';

        const hasRecommendations = Boolean(recommendations?.querySelector('.grid__item:not(.product-recommendations__skeleton-card)'));
        this.classList.remove('product-recommendations--loading');

        if (hasRecommendations) {
          this.loaded = true;
          this.classList.add('product-recommendations--loaded');
        } else {
          this.loaded = false;
          this.classList.remove('product-recommendations--loaded');
        }

        this.resetSlider();
        if (typeof lazyImages === 'function') lazyImages();
        return hasRecommendations;
      } catch (e) {
        if (Number(this.dataset.guardUntil)) this.innerHTML = '';
        this.loaded = false;
        console.error(e);
        return false;
      } finally {
        this.loading = false;
      }
    }

    clearLoadRetry() {
      window.clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }

    scheduleLoadRetry(callback) {
      if (this.loaded || this.retryTimeout || !this.isConnected || this.retryLimitReached) return;
      if (this.retryAttempts >= this.maxRetryAttempts) {
        this.retryLimitReached = true;
        this.classList.remove('product-recommendations--loading');
        this.innerHTML = '';
        this.recommendationsObserver?.disconnect();
        return;
      }

      this.retryAttempts += 1;
      this.retryTimeout = window.setTimeout(() => {
        this.retryTimeout = null;
        callback();
      }, 2000 * this.retryAttempts);
    }

    resetSlider() {
      const slider = this.closest('slider-component');
      const sliderList = slider?.querySelector('.slider');
      if (!slider || !sliderList || typeof slider.initPages !== 'function') return;

      const sliderId = sliderList.getAttribute('id');
      const prevButton = slider.querySelector(`button[name="previous"][aria-controls="${sliderId}"]`);
      const nextButton = slider.querySelector(`button[name="next"][aria-controls="${sliderId}"]`);
      const sliderComponentAlreadyBound = slider.slider === sliderList && slider.prevButton === prevButton && slider.nextButton === nextButton;

      slider.slider = sliderList;
      slider.sliderItems = slider.slider.querySelectorAll('.slider__slide');
      slider.currentPageElement = slider.querySelector('.slider-counter--current');
      slider.pageTotalElement = slider.querySelector('.slider-counter--total');
      slider.prevButton = prevButton;
      slider.nextButton = nextButton;

      if (!slider.prevButton || !slider.nextButton) return;

      if (
        !sliderComponentAlreadyBound &&
        (slider.productRecommendationsBoundSlider !== slider.slider ||
          slider.productRecommendationsBoundPrevButton !== slider.prevButton ||
          slider.productRecommendationsBoundNextButton !== slider.nextButton)
      ) {
        slider.productRecommendationsResizeObserver?.disconnect();

        slider.productRecommendationsOnScroll = slider.update.bind(slider);
        slider.productRecommendationsOnPreviousClick = slider.onButtonClick.bind(slider);
        slider.productRecommendationsOnNextClick = slider.onButtonClick.bind(slider);
        slider.slider.addEventListener('scroll', slider.productRecommendationsOnScroll);
        slider.prevButton.addEventListener('click', slider.productRecommendationsOnPreviousClick);
        slider.nextButton.addEventListener('click', slider.productRecommendationsOnNextClick);
        slider.productRecommendationsBoundSlider = slider.slider;
        slider.productRecommendationsBoundPrevButton = slider.prevButton;
        slider.productRecommendationsBoundNextButton = slider.nextButton;

        if ('ResizeObserver' in window) {
          slider.productRecommendationsResizeObserver = new ResizeObserver(() => slider.initPages());
          slider.productRecommendationsResizeObserver.observe(slider.slider);
        }
      }

      slider.initPages();
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
